import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { path } from 'ramda';
import bindAllActions from '../../common/bindAllActions';
import SubscriptionTabs from './SubscriptionTabs';
import { DisplayCard, AllPayments, userHasCardOnFile } from './';
import './PaymentDetailsPage.less';

function PaymentDetailsPage({ user, userActions }) {
  const [hasPaymentMethod, setHasPaymentMethod] = useState(!!userHasCardOnFile(user));

  // Sync state when user data changes
  useEffect(() => {
    setHasPaymentMethod(!!userHasCardOnFile(user));
  }, [user]);

  // Extract userId for AllPayments
  const userId = path(['info', '_id'], user);

  // Stable callback for AllPayments to prevent excessive re-renders
  const handleCardSuccess = useCallback(() => {
    setHasPaymentMethod(true)
  }, [])

  return (
    <div className="payment-details-page">
      <header className='main'>
        <h1>
          Features & Subscriptions
        </h1>
      </header>
      <SubscriptionTabs currentTab="payment" />
      <div className='page-body'>
        <div className='block'>
          <h3>Payment Details</h3>
          <p>Add or remove your payment method. It will be used for subscription renewals if you choose to enable auto-renew.</p>

          {userId && (
            <div className='card-management-section'>
              <DisplayCard />
              <AllPayments
                userId={userId}
                mode='file'
                onSuccess={handleCardSuccess}
              />
            </div>
          )}

          {
            hasPaymentMethod && (
              <div className='btns'>
                <Link className='btn btn-primary' to='/subscriptions'>Manage Subscriptions</Link>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

export default bindAllActions(PaymentDetailsPage);

PaymentDetailsPage.propTypes = {};
PaymentDetailsPage.defaultProps = {};
PaymentDetailsPage.displayName = 'PaymentDetailsPage';
